module.exports = __webpack_public_path__ + "img/logo.c2f5bbc4.png";